import React, { useState, useEffect } from 'react';
import FromExp from './row/FromExp';
import ToExp from './row/ToExp';
import SolutionExp from './row/SolutionExp';
import Standard from './row/Standard';
import SolutionStandard from './row/SolutionStandard';

const Row = ({id, number, randomPrefFrom, randomPrefTo, randomUnit, expSolution, standardSolution, standardExpSolution, checkExp, checkStand }) => {
    const [exp, setExp] = useState('');
    const [stand, setStand] = useState('');
    const [expStand, setExpStand] = useState('');

    useEffect(() => {
        setExp('');
        setStand('');
        setExpStand('');
    }, [number, randomPrefFrom, randomPrefTo, randomUnit]);

    return (
        <tr>{console.log('ROW.JS')}
            <FromExp { ...{ number, randomPrefFrom, randomUnit }} />
            <ToExp { ...{ id, number, randomPrefTo, randomUnit, exp, setExp, expSolution, checkExp }} />
            { checkExp && <SolutionExp { ...{ number, randomPrefTo, randomUnit, expSolution }} /> }
            <Standard { ...{ id, stand, setStand, expStand, setExpStand, randomPrefTo, randomUnit, standardSolution, standardExpSolution, checkStand }}/>
            { checkStand && <SolutionStandard { ...{ standardSolution, standardExpSolution, randomPrefTo, randomUnit }}/> }
        </tr>
    )
}

export default Row;
